export const NAME = 'login';

// Actions Types pour logger le user
export const REQUEST_LOGIN = 'REQUEST_LOGIN';
export const SUCCESS_LOGIN = 'SUCCESS_LOGIN';
export const FAILURE_LOGIN = 'FAILURE_LOGIN';

export const RESET_LOGIN_FORM = 'RESET_LOGIN_FORM';



// WEBPACK FOOTER //
// ./src/services/authentication/login/constants.js